import { ApiShopperLandingPage } from '@storefronts/common-types'
import Script from 'next/script'

export const NorthbeamPixel: React.FC<{
    landingPage: ApiShopperLandingPage
}> = ({ landingPage }) => {
    if (!landingPage.integrations.northbeamPixelId) return null

    return (
        <Script id="northbeam-tracking" strategy="afterInteractive">
            {`
                (function(){
                    var r;
                    (e=r=r||{}).A="identify",
                    e.B="trackPageView",
                    e.C="fireEmailCaptureEvent",
                    e.D="fireCustomGoal",
                    e.E="firePurchaseEvent",
                    e.F="firePurchaseSyncEvent";
                    var e="//j.northbeam.io/ota-sp/${landingPage.integrations.northbeamPixelId}.js";
                    function t(e){
                        for(var n=[],r=1;r<arguments.length;r++)
                            n[r-1]=arguments[r];
                        a.push({fnName:e,args:n})
                    }
                    var a=[],
                    n=((n={_q:a})[r.A]=function(e,n){return t(r.A,e,n)},
                    n[r.B]=function(){return t(r.B)},
                    n[r.C]=function(e,n){return t(r.C,e,n)},
                    n[r.D]=function(e,n){return t(r.D,e,n)},
                    n[r.E]=function(e){return t(r.E,e)},
                    n[r.F]=function(e){return t(r.F,e)},
                    window.Northbeam=n,
                    document.createElement("script"));
                    n.async=!0,
                    n.src=e,
                    document.head.appendChild(n);
                    window.Northbeam.trackPageView();
                })()
            `}
        </Script>
    )
}
